import { API, overlay, YOUTUBE_API, YOUTUBE_API_KEY } from "./config.js"
import { getData, getYouTubeData, sendData, sendImage } from "./data.js"
import { renderFile, renderSearchResult, renderText, renderUploadImage, renderWeaponImages, renderWeaponPage, renderYouTubePlayList, renderYouTubeVideo, rendreWeaponImg } from "./views/weaponPage.js"
import { initTynymce } from "./healpers.js";
import { loadWeaponPage } from "./weapon.js";

const editWeapon = () => {
    const editWeaponBtn = document.querySelector('.weapon-edit')

    editWeaponBtn.addEventListener('click', e => {
        const target = e.target
        if(target.classList.contains('weapon-edit')) {
            target.querySelector('.weapon-edit-box').classList.toggle('active')
            target.querySelector('.close').classList.toggle('active')
            target.querySelector('.more').classList.toggle('active')
            target.classList.toggle('active')
        }
    })
}

const weaponGallerySlider = (num) => {
    const gallerySlides = document.querySelectorAll('.weapon-gallery-item');
    const arrowNext = document.querySelector('.weapon-gallery-arrow.arrow-right');
    const arrowPrev = document.querySelector('.weapon-gallery-arrow.arrow-left');
    let currentSlide = num;

    const moveToSlide = (slideNumber) => {
        gallerySlides.forEach((slide, index) => slide.style.transform = `translateX(${(index - slideNumber) * 100}%)`)
    }
    moveToSlide(currentSlide)

    arrowNext.addEventListener('click', () => {
        if(currentSlide < gallerySlides.length - 1) {
            currentSlide++
        } else {
            currentSlide = 0;
        }
        moveToSlide(currentSlide)
    })
    arrowPrev.addEventListener('click', () => {
        if(currentSlide === 0) {
            currentSlide = gallerySlides.length - 1;
        } else {
            currentSlide--
        }
        moveToSlide(currentSlide)
    })
}

const closeUploadModal = (element) => {
    element.addEventListener('click', () => {
        document.querySelector('.upload-modal').remove();
        overlay.classList.remove('active')
    })
}

const showUploadModal = (id) => {
    const addImageBtns = document.querySelectorAll('.add-image-btn');

    addImageBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            renderUploadImage(id)
            fileLoad()
            overlay.classList.add('active')
        })
    })
    closeUploadModal(overlay)
}

const uploadImage = () => {
    const form = document.querySelector('#upload-img')

    const data = new FormData(form)
    
    return data
}

const fileLoad = () => {
    const fileInput = document.querySelector('.upload-input')
    const uploadBtn  = document.querySelector('.upload-btn')

    fileInput.addEventListener('change', e => {
        const file = e.target.files[0]
        const url = URL.createObjectURL(file)

        renderFile(url)
        uploadBtn.classList.remove('disabled')
        uploadBtn.removeAttribute('disabled')

        uploadBtn.addEventListener('click', ev => {
            ev.preventDefault()
            sendImage(`${API}add-image`, uploadImage())
            .then(data => {
                rendreWeaponImg(data)
                weaponGallerySlider(0)
            })
            document.querySelector('.upload-modal').remove();
            overlay.classList.remove('active')
        })
        
    })
}


const deletImage = () => {
    const weaponGallery = document.querySelector('.weapon-gallery-box');

    weaponGallery.addEventListener('click', e => {
        const btn = e.target
        if(btn.classList.contains('delete-image')) {
            const image = btn.closest('.weapon-gallery-item');
            const obj = {
                id: image.querySelector('img').getAttribute('id')
            }
            sendData(`${API}delete-image`, obj)
            image.remove()
            weaponGallerySlider(0)
        }
    })
}

const loadImages = (id) => {
    getData(`${API}get-images/${id}`)
    .then(data => {
        renderWeaponImages(data)
        weaponGallerySlider(0)
        showUploadModal(id)
        deletImage()
    })
}

const editText = () => {
    const textContainer = document.querySelector('.weapon-text-content');
    const textFrame = document.getElementById('weapon-text_ifr').contentDocument;

    textFrame.body.innerHTML = textContainer.innerHTML;
    textContainer.innerHTML = ''
}

const showTextEditor = () => {
    const editTextBtns = document.querySelectorAll('.add-text-btn');

    editTextBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            initTynymce().then(res => {
                editText()
                document.querySelector('.weapon-text-editor').style.display = 'block';
            })
        })
    })
}

const saveText = (id, name) => {
    const saveBtn = document.querySelector('.save-weapon-text');
    const textEditor = document.querySelector('.weapon-text-editor');
    const textContent = document.querySelector('.weapon-text-content')

    saveBtn.addEventListener('click', e => {
        e.preventDefault()
        const textFrame = document.getElementById('weapon-text_ifr').contentDocument;
        const text = textFrame.querySelector('body').innerHTML;

        tinymce.remove();
        textContent.innerHTML = text;
        textEditor.style.display = 'none';

        const obj = {
            id: id,
            title: name,
            body: text,
        }
        sendData(`${API}add-article`, obj)
    })
}

const videoStart = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
})

const emmbedYouTubeVideo = (video) => {
    const videoContainer = document.querySelector('.weapon-gallery-box');
    const galleryItems = document.querySelectorAll('.weapon-gallery-item')
    renderYouTubeVideo(videoContainer, video)
    weaponGallerySlider(galleryItems.length)

    document.querySelector('iframe').dispatchEvent(videoStart)
}

const loadYouTubePlayer = () => {
    const weaponVideoList = document.querySelector('.weapon-video-box');

    weaponVideoList.addEventListener('click', e => {
        if(e.target.classList.contains('weapon-video-preview')) {
            const videoId = e.target.getAttribute('id');
            getYouTubeData(`${YOUTUBE_API}videos?key=${YOUTUBE_API_KEY}&id=${videoId}&part=player&maxWidth=1100`)
            .then(video => {
                console.log(video);
                const videoItem = video.items[0];
                console.log(videoItem.player.embedHtml);
                emmbedYouTubeVideo(videoItem.player.embedHtml)
            })
        }
    })
}

const loadYouTubeList = (key) => {
    getYouTubeData(`${YOUTUBE_API}search?key=${YOUTUBE_API_KEY}&q=${key}&part=snippet&maxResults=10&regionCode=ru&type=video&videoEmbeddable=true`)
    .then(res => {
        renderYouTubePlayList(res.items)
        loadYouTubePlayer()
    })
}

const loadText = (id) => {
    getData(`${API}get-article/${id}`)
    .then(data => {
        renderText(data)
        showTextEditor()
    })
}

const navToWeaponPage = () => {
    const searchResultContainer = document.querySelector('.header-search-result');

    searchResultContainer.addEventListener('click', e => {
        e.preventDefault();
        if(e.target.classList.contains('search-result-item')) {
            const weaponID = e.target.getAttribute('href').slice(1);
            loadWeaponPage(weaponID)
        }
    })
}

const searchOnWeaponPage = () => {
    const searchInput = document.querySelector('.header-search-input');
    const searchResultContainer = document.querySelector('.header-search-result');

    searchInput.addEventListener('input', e => {
        const value = e.target.value;
        if(value !== '') {
            getData(`${API}armaments`)
            .then(data => {
                searchResultContainer.innerHTML = ''
                const result = data.data.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
                searchResultContainer.insertAdjacentHTML('afterbegin', renderSearchResult(result))
            })
        } else {
            searchResultContainer.innerHTML = ''
        }
        
    })
    navToWeaponPage()
}

export const initWeaponPage = (id, name) => {
    renderWeaponPage(name)
    loadImages(id)
    loadText(id)
    loadYouTubeList(name)
    editWeapon()
    saveText(id, name)
    searchOnWeaponPage()
}


